export const VEHICLE_HISTORY_KEY = 'vehicle_search_history'

const VEHICLE_HISTORY_TTL_MS = 30 * 24 * 60 * 60 * 1000

const normalizeSearch = search => {
  if (!search) return ''
  return String(search).trim().toUpperCase().replace(/\s+/g, '')
}

export const vehicleHistoryKey = vehicle => {
  const normalized = normalizeSearch(vehicle.search)
  return normalized ? `${vehicle.id}_${normalized}` : `${vehicle.id}`
}

const safely = fn => {
  try {
    return fn()
  } catch {
    return null
  }
}

export const readVehicleHistory = () => {
  if (typeof window === 'undefined') return null
  return safely(() => {
    const raw = window.localStorage.getItem(VEHICLE_HISTORY_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (Array.isArray(parsed)) return parsed
    if (!parsed || !Array.isArray(parsed.items)) return null
    if (Date.now() - (parsed.saved_at || 0) > VEHICLE_HISTORY_TTL_MS) {
      window.localStorage.removeItem(VEHICLE_HISTORY_KEY)
      return null
    }
    return parsed.items
  })
}

export const writeVehicleHistory = items => {
  if (typeof window === 'undefined') return
  safely(() =>
    window.localStorage.setItem(
      VEHICLE_HISTORY_KEY,
      JSON.stringify({ saved_at: Date.now(), items })
    )
  )
}

export const clearVehicleHistory = () => {
  if (typeof window === 'undefined') return
  safely(() => window.localStorage.removeItem(VEHICLE_HISTORY_KEY))
}
